import React,{useState,useEffect} from 'react';
import { Grid,Box,Checkbox,FormControlLabel,FormGroup, Button} from '@mui/material';
import { useSelector } from 'react-redux';
import { useGetTenantSetting,useAddSettings} from '../../Hooks/index';
import CheckIcon from '@mui/icons-material/Check';
import {ReactComponent as SettingVector} from '../../StaticData/Svgs/settingVector.svg';
import SettingsIcon from '@mui/icons-material/Settings';
import DYToastMessage from '../../../../../src/components/GlobalComponents/DyToastMessage/DYToastMessage';
import { TextField } from '@mui/material';
import LoadingSpinner from '../../../../components/Progress/LoadingSpinner';

interface settingItemFace{
    key:string,
    title:string,
    valueOfKey:string,
    value:boolean
}

const MainSetting = () => {
    const tenantId: any = useSelector((state: any) => state.meetings.profileTenantId);
    const{data:tenantSettingsData,isLoading:getTenantSettinLoading,isFetched}=useGetTenantSetting(tenantId);
    const{mutate:callAddTenantSetting,isSuccess:changeSettingSuccess,isLoading:changeSettingLoading,data:settingData}=useAddSettings()
    const[SettingsState,setSettingsState]=useState<settingItemFace[]>([]);
    const[remainData,setRemainData]=useState<any>(null);
    const[asyncState,setAsyncState]=useState<any>({
      success:false,
      loading:false
    });

    // const[disabledSub,setDisabledSub]=useState<any>(false);
    // const[initSett,setInitSett]=useState<any>(null);
    const [loginStatusLocal, setLoginStatusLocal] = useState<boolean | null>(null);
    const [loginMessage, setLoginMessage] = useState<string | null>(null)
    const loginStatus: any = useSelector((state: any) => state.loign.loginStatus);
    const [showAddLicense, setShowAddLicense] = useState<boolean>(false);
    const [showToastMessage, setShowToastMessage] = useState<boolean>(false);
    const initialChangeSetting=(key:string,value:boolean)=>{
      setAsyncState({
        success:false,
        loading:false
      })
      // setDisabledSub(false)
        setSettingsState((prev:any)=>(prev.map((item:any)=>{
        if (item.key===key) {
            return { ...item, value: !item.value }; 
        }
        return item;
        })))
    }
    
    useEffect(() => {
   setAsyncState((prev:any)=>({...prev,success:changeSettingSuccess}))
    }, [changeSettingSuccess])

    useEffect(() => {
      setAsyncState((prev:any)=>({...prev,loading:changeSettingLoading}))
       }, [changeSettingLoading])
    
        useEffect(() => {
        if (tenantSettingsData && isFetched ) {
          let{settings,...rest}:any=tenantSettingsData
          setSettingsState(settings);
          setRemainData(rest)
        }
        }, [isFetched])

        const initialAddSetting=()=>{
          console.log({settings:[...SettingsState],...remainData})
            callAddTenantSetting({settings:[...SettingsState],...remainData})
        }

        useEffect(() => {
          if (settingData) {
            let { data: { isSuccess, data, metaData } }: any = settingData;
            let { message }: any = metaData;
            let logStatus = { success: isSuccess };
            setLoginMessage(message);
            setLoginStatusLocal(!loginStatus)
          }
        }, [settingData])

        if (getTenantSettinLoading) {
          return <Box width={'100%'} py={6} textAlign={'center'}   >
              <LoadingSpinner/>
          </Box>
        }
        
        const initialAddLicense = (): void => {
          setShowAddLicense((prev) => !prev);
        };


  return (
   <Grid container   >
   <Grid item xs={12}  md={6} > 
   <Box
   margin={4}
   borderColor={'#EAEAEA '}
   borderRadius={10}
   boxShadow={10}
     py={2}
     px={4}
    width={'100%'}
    height={'100%'}
    display={'flex'}
    flexDirection={'column'} alignItems={'start'} >
   {
    SettingsState && SettingsState.map((item: settingItemFace, i: number) => {
        let { key, value, title, valueOfKey } = item;
        return (
            <FormGroup key={i} sx={{ px: 4, py: 1 }}>
                <FormControlLabel
                    checked={value}
                    control={<Checkbox />}
                    label={title}
                    onChange={(event: any) => {
                        initialChangeSetting(key, event.target.checked);
                    }}
                />
                {item.valueOfKey && (
                    <TextField
    label="مقدار عددی"
    type="text"
    variant="outlined"
    value={
        parseFloat(valueOfKey) < 0 
            ? `${Math.abs(parseFloat(valueOfKey))}-` 
            : valueOfKey || 0
    }
    onChange={(e) => {
        const newValue = e.target.value;
        setSettingsState((prev: settingItemFace[]) =>
            prev.map((it) =>
                it.key === key ? { ...it, valueOfKey: newValue } : it
            )
        );
    }}
    sx={{ mt: 1 }}
/>

                )}
            </FormGroup>
        );
    })
}
   </Box>
   </Grid>
   <Grid item xs={12}  md={6}>
   <Box   
   display={'flex'} 
   flexDirection={'column-reverse'} 
   justifyContent={'space-between'} 
   alignItems={'center'}
   minHeight={'100%'} >
    <Box  mb={2} >
    <Button 
    endIcon={asyncState.success?<CheckIcon/>:<SettingsIcon/>}
    disabled={false}
    sx={{fontSize:'18px',px:6,py:1,bgcolor:'#00387C',borderRadius:10  }}
    variant='contained' 
     onClick={()=>{
     initialAddSetting()
    }}  >
      ثبت تنظیمات
    </Button>
    </Box>
    <Box>
      <SettingVector style={{width:'550px'}}  />
    </Box>
    <div>
     </div>
   </Box>
   </Grid>
   {
        loginStatusLocal && loginMessage &&
        <DYToastMessage
          show={!loginStatus}
          setShow={setLoginStatusLocal}
          message={loginMessage}
          isSuccess={loginMessage ===  "شما دسترسی تغییر تنظیمات را ندارید" ? false:true}
        />
      }
      {
        showToastMessage &&
        <DYToastMessage
          show={!loginStatus}
          setShow={setLoginStatusLocal}
          message={'عملیات باموفقیت انجام شد'}
          isSuccess={loginMessage ===  "شما دسترسی تغییر تنظیمات را ندارید" ? false:true}
        />
      }
   </Grid>
  )
}

export default MainSetting
